import { jsx as e, Fragment as j, jsxs as p } from "react/jsx-runtime";
import { useMemo as I } from "react";
const U = ({
  skuSpecifications: t,
  hasPromotionalPrice: C,
  clubPrice: i,
  unitMultiplier: h,
  defaultScListPrice: n,
  customOffers: r,
  measurementUnit: N,
  isClubClient: g,
  hasPlusFriendBadge: v
}) => {
  const { listPrice: s, spotPrice: c } = C || {}, { listPriceCustom: m, spotPriceCustom: P } = I(() => s && c && c !== r.spotPriceCustom ? {
    listPriceCustom: s,
    spotPriceCustom: c
  } : {
    listPriceCustom: r.listPriceCustom,
    spotPriceCustom: r.spotPriceCustom
  }, [
    s,
    c,
    r.spotPriceCustom,
    r.listPriceCustom
  ]), b = !!(i && i !== r.spotPriceCustom), B = !!(n && n !== P), l = (o) => o.toLocaleString("pt-br", { style: "currency", currency: "BRL" }), w = "Venda por unidade", u = t == null ? void 0 : t.some((o) => o.field.originalName === w && o.values.some((F) => F.originalName === "true")), x = N !== "un", a = n || (u ? m : ((o) => Number(o.toString().match(/^\d+(?:\.\d{0,2})?/)))(m * h)), y = v ? "no + Amigo" : "no clube", d = x && r.spotPriceKg && u ? r.spotPriceKg : P, D = (a > d || B) && a && d;
  return /* @__PURE__ */ e(j, { children: /* @__PURE__ */ p("div", { className: "product-card-price", children: [
    !g && b && /* @__PURE__ */ e("div", { className: "product-card-club-price-container", children: /* @__PURE__ */ e("p", { className: "product-card-club-price", children: `${l(i || 0)} ${y}` }) }),
    /* @__PURE__ */ p("div", { className: "product-card-price-container", children: [
      D && /* @__PURE__ */ e("p", { className: "product-card-old-price", children: /* @__PURE__ */ p("span", { children: [
        " ",
        l(a)
      ] }) }),
      /* @__PURE__ */ e("p", { className: "product-card-new-price", children: l(d) })
    ] })
  ] }) });
};
export {
  U as ProductCardPrice
};
